export interface userParam {
  "tforid": string,
  "utype": string,
  "qparm": string,
  "uid": string,
  "rcid": string,
  "mode": string,
  "ip": string,
  "devicetype": number,
  "policy": number,
  "tierid": number,
  "decisionCode": number,
  "serviceType": number,
  "activityToken": string,
  "surveyId": number,
  "isTabSwitch"?: boolean
}

export interface userCallbackParam {
  "TOID": string,
  "Status": number,
  "SubId": string,
  "IP": string,
  "referrer": string
}

/**
 * Angular queryParams returns string[] when a key is repeated.
 * Always coerce to a single string for API payloads (uses first value, same as URLSearchParams.get).
 */
export function asQueryString(value: any, fallback: string = ''): string {
  if (value === undefined || value === null) {
    return fallback;
  }
  if (Array.isArray(value)) {
    return value.length ? String(value[0]) : fallback;
  }
  return String(value);
}
